import styles from './presentation_listing.module.sass'

import { useEffect, useState } from 'react'

import BlockWrapper from './layout/block_wrapper'
import Image from './basic/image'
import Accordion from './accordion'

import classNames from 'classnames'

import config from '../config'

function PresentationListing(props) {
	const fields = props.fields
	const [modalOpen, setModalOpen] = useState(false)
	const [activeImage, setActiveImage] = useState(fields.presentations[0]?.media)
	const [isMobile, setIsMobile] = useState(Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) < config.mobileWidth)

	//if there is a <!--more--> tag, keep the first part and move the rest into a "more_content" field
	if(fields.presentations.length > 0){
		fields.presentations.forEach(presentation => {
			if (presentation.content.includes('<!--more-->')) {
				const [firstPart, moreContent] = presentation.content.split('<!--more-->')
				presentation.content = firstPart
				presentation.more_content = moreContent
			}
		})
	}

	const toggleMediaModal = (image) => {
		setModalOpen(!modalOpen)
		document.body.classList.toggle('overlay_open')
		if (image) {
			setActiveImage(image)
		}
	}

	const handleModalClick = (image) => {
		if (isMobile) {
			return
		}

		toggleMediaModal(image)
	}

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) < config.mobileWidth)
		}
		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [])

	return <BlockWrapper {...props} className={styles.presentation_listing}>
		<div className={styles.listing_wrapper}>
			{fields.presentations.map((presentation, i) => {
				return <div key={i} className={styles.presentation_wrapper}>
					{presentation.media && <div className={styles.media_wrapper} onClick={() => {handleModalClick(presentation.media)}}>
						<Image {...presentation.media} className={styles.media} />
						<span className={styles.expander} />
					</div>}
					<div className={styles.content_wrapper}>
						<div className={styles.content} dangerouslySetInnerHTML={{__html: presentation.content}}></div>
						{presentation.more_content && <Accordion theme="theme_2" toggle="toggle_small" fields={{items: [{title: 'Read More', raw_content: presentation.more_content}]}} />}
					</div>
				</div>
			})}
		</div>
		<div className={classNames(styles.modal, modalOpen ? styles.open : '')}>
			<div className={styles.modal_inner}>
				<div className={styles.modal_close} onClick={() => {handleModalClick()}}></div>
				<div className={styles.modal_content_wrapper}>
					<Image {...activeImage} sizeOverride="90vw"/>
				</div>
			</div>
		</div>
	</BlockWrapper>
}

export default PresentationListing